/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Select_Fallback_ColorInputs */

const en_admin_resource_form_select_fallback_color = /** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select fallback color`)
};

const de_admin_resource_form_select_fallback_color = /** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausweichfarbe auswählen`)
};

const es_admin_resource_form_select_fallback_color = /** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar color alternativo`)
};

const fr_admin_resource_form_select_fallback_color = /** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner une couleur par défaut`)
};

/** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */
const it_admin_resource_form_select_fallback_color = en_admin_resource_form_select_fallback_color;

/** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */
const pt_br2_admin_resource_form_select_fallback_color = en_admin_resource_form_select_fallback_color;

/** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */
const pl_admin_resource_form_select_fallback_color = en_admin_resource_form_select_fallback_color;

/** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */
const hu_admin_resource_form_select_fallback_color = en_admin_resource_form_select_fallback_color;

/** @type {(inputs: Admin_Resource_Form_Select_Fallback_ColorInputs) => LocalizedString} */
const ro_admin_resource_form_select_fallback_color = en_admin_resource_form_select_fallback_color;

/**
* | output |
* | --- |
* | "Select fallback color" |
*
* @param {Admin_Resource_Form_Select_Fallback_ColorInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_select_fallback_color = /** @type {((inputs?: Admin_Resource_Form_Select_Fallback_ColorInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Select_Fallback_ColorInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_select_fallback_color(inputs)
	if (locale === "de") return de_admin_resource_form_select_fallback_color(inputs)
	if (locale === "es") return es_admin_resource_form_select_fallback_color(inputs)
	if (locale === "fr") return fr_admin_resource_form_select_fallback_color(inputs)
	if (locale === "it") return it_admin_resource_form_select_fallback_color(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_select_fallback_color(inputs)
	if (locale === "pl") return pl_admin_resource_form_select_fallback_color(inputs)
	if (locale === "hu") return hu_admin_resource_form_select_fallback_color(inputs)
	return ro_admin_resource_form_select_fallback_color(inputs)
});
export { admin_resource_form_select_fallback_color as "admin.resource_form.select_fallback_color" }